import React, { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../firebase";
import { FaPhoneAlt, FaVideo, FaArrowDown, FaArrowUp, FaLink, FaUserCircle } from "react-icons/fa";

function CallsList({ currentUser }) {
  const [calls, setCalls] = useState([]);
  const [users, setUsers] = useState({});

  useEffect(() => {
    // Load Users
    const usersRef = ref(db, "users");
    onValue(usersRef, (snapshot) => {
      setUsers(snapshot.val() || {});
    });

    // Load Calls for current user
    if (!currentUser) return;
    const callsRef = ref(db, `calls/${currentUser.uid}`);
    onValue(callsRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) {
        setCalls([]);
        return;
      }
      const callList = Object.entries(data).map(([id, value]) => ({
        id,
        ...value
      })).sort((a, b) => b.timestamp - a.timestamp);
      setCalls(callList);
    });
  }, [currentUser]);

  return (
    <div className="sidebar-view calls-view">
      <div className="sidebar-header">
        <h2>Calls</h2>
        <div className="sidebar-header-actions">
          <FaPhoneAlt title="New Call" />
        </div>
      </div>

      <div className="chat-list">
        {/* COMING SOON BANNER */}
        <div style={{ margin: '12px 14px 6px 14px', padding: '12px 14px', background: 'rgba(0, 168, 132, 0.1)', border: '1px solid rgba(0, 168, 132, 0.25)', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaVideo style={{ fontSize: '18px', color: '#00a884' }} />
            <div>
              <div style={{ fontWeight: '700', fontSize: '13px', color: 'var(--text-primary)' }}>Voice & Video Calls</div>
              <div style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>Encrypted high-speed calls</div>
            </div>
          </div>
          <span style={{ background: '#00a884', color: 'white', fontSize: '10px', fontWeight: '800', padding: '3px 8px', borderRadius: '100px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Coming Soon</span>
        </div>

        {/* CALL LINK */}
        <div className="chat-item">
          <div className="avatar" style={{ background: '#00a884', color: 'white' }}>
            <FaLink />
          </div>
          <div className="chat-item-content">
            <div className="chat-info">
              <div className="chat-top">
                <h4>Create call link</h4>
              </div>
              <p className="preview">Share a link for your Bharat call</p>
            </div>
          </div>
        </div>

        <div className="section-divider" style={{ padding: '15px', fontSize: '14px', color: 'var(--text-secondary)', fontWeight: 'bold' }}>
          RECENT
        </div>

        {calls.length > 0 ? (
          calls.map((call) => {
            const otherUser = users[call.otherUid] || {};
            return (
              <div className="chat-item" key={call.id}>
                <div className="avatar">
                  {otherUser.photoURL ? (
                    <img src={otherUser.photoURL} alt={otherUser.name} />
                  ) : (
                    <FaUserCircle style={{ color: 'var(--icon-color)', fontSize: '30px' }} />
                  )}
                </div>
                <div className="chat-item-content">
                  <div className="chat-info">
                    <div className="chat-top">
                      <h4>{otherUser.name || "Unknown"}</h4>
                      {call.type === "video" ? <FaVideo /> : <FaPhoneAlt />}
                    </div>
                    <p className="preview">
                      {call.direction === "incoming" ? (
                        <FaArrowDown style={{ color: call.missed ? '#ef4444' : '#00a884', marginRight: '5px', transform: 'rotate(45deg)' }} />
                      ) : (
                        <FaArrowUp style={{ color: '#00a884', marginRight: '5px', transform: 'rotate(45deg)' }} />
                      )}
                      {new Date(call.timestamp).toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                    </p>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-secondary)', fontSize: '14px' }}>
            No recent calls found.
          </div>
        )}
      </div>
    </div>
  );
}

export default CallsList;
